import keyMirror from 'keymirror-nested'

export default keyMirror({
  PRIMARY_TAB: {
    UPDATE: null,
  },
})
